export default __webpack_public_path__ + "static/media/관리자.9532d141.png";